var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Mobile/SolutionsMenu.js",
  _this = this;
import React, { useContext } from 'react';
import { List } from '@wds/list';
import { SubMenuLink } from './components/SubMenuLink';
import { SeeMoreLink } from './components/SeeMoreLink';
import SolutionByNeed from './components/SolutionByNeed';
import { customerFeedback, employeeFeedback, marketResearch, customerExperience, humanResources, marketing, customerSatisfaction, customerLoyalty, eventSurveys, employeeEngagement, jobSatisfaction, hrSurveys, marketResearchSurveys, opinionPolls, conceptTesting, exploreSurveyTypes } from '../../config/linkInfo.js';
import SMHeaderContext from '../../SMHeaderContext';
export var SolutionsMenu = function SolutionsMenu() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  return /*#__PURE__*/React.createElement(List, {
    interactive: true,
    transparent: true,
    noRules: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, lang === 'en' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, customerFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, employeeFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, marketResearch(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, customerExperience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, humanResources(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, marketing(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, customerFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, employeeFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, marketResearch(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, customerSatisfaction(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, customerLoyalty(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, eventSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, employeeEngagement(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, jobSatisfaction(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, hrSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, marketResearchSurveys(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, opinionPolls(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SolutionByNeed, Object.assign({}, conceptTesting(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SeeMoreLink, Object.assign({}, exploreSurveyTypes(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  })));
};
export default SolutionsMenu;
//# sourceMappingURL=SolutionsMenu.js.map